import { Card, FontIcon } from "@ezmid/components-library";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

import { CreateLessonModal } from "./CreateLessonModal";
import { useGetBackOfficeGetCourseUsersQuery } from "../../../api/courses-users.generated";
import { EntityCourse } from "../../../api/courses.generated";
import { useGetBackOfficeListLecturersQuery } from "../../../api/lecturers.generated";
import { LessonsTable } from "../../../components/tables/LessonsTable";
import { UsersTable } from "../../../components/tables/UsersTable";
import { PageLoader } from "../../loader/PageLoader";
import { CourseEditForm } from "../molecules/CourseEditForm";

type Props = {
  isModalOpen: boolean;
  currentData?: EntityCourse;
  isFetching: boolean;
  id?: string;
  courseRefetch: () => void;
  onModalClose: () => void;
};

export function CourseDetailPageContent({
  isFetching,
  currentData,
  id,
  courseRefetch,
  isModalOpen,
  onModalClose,
}: Props) {
  const { t } = useTranslation();
  const { currentData: courseUsers, isFetching: isFetchingUsers } =
    useGetBackOfficeGetCourseUsersQuery({
      id: id || "",
      page: 1,
      size: 100,
    });
  const { currentData: lecturersData } = useGetBackOfficeListLecturersQuery({
    size: 1000,
  });

  const lecturerOptions = lecturersData?.items?.map(
    ({ id: lecturerID, fullName }) => ({
      value: lecturerID || "",
      label: fullName || "",
    })
  );

  const users = courseUsers?.items?.map((item) => item.user);

  return (
    <>
      {isFetching ? (
        <PageLoader />
      ) : (
        <div className="w-full min-w-full flex">
          <div className="w-1/2 p-2">
            <Card
              shadows="xl"
              size="fill"
              headerText={t("course.informations")}
              headerIcon={
                <FontIcon
                  marginTop={4}
                  customIcon={<FontAwesomeIcon icon={faInfoCircle} />}
                />
              }
            >
              <CourseEditForm
                courseData={currentData}
                refetch={courseRefetch}
                lecturerOptions={lecturerOptions || []}
              />
            </Card>
          </div>
          <div className="w-1/2 p-2 flex flex-col gap-4">
            <LessonsTable
              isFetching={isFetching}
              lessons={currentData?.lessons || []}
              headerText={t("course.lessons.header")}
              courseId={id}
              refetch={courseRefetch}
            />
            <UsersTable
              users={users || []}
              headerText={t("course.users")}
              isFetching={isFetchingUsers}
            />
          </div>
        </div>
      )}
      {isModalOpen ? (
        <CreateLessonModal
          onModalClose={onModalClose}
          courseId={id || ""}
          refetch={courseRefetch}
          isModalOpen={isModalOpen}
        />
      ) : null}
    </>
  );
}
